export default {
    name: 'link-rendering-scope-slot',
    props: {
        scopeSlotFunc: {
            type: Function,
            required: true
        },
        data: {},
    },
    render(h) {
        return (
            <div class="link-rendering-scope-slot">
                {!!this.scopeSlotFunc && this.scopeSlotFunc(this.data)}
            </div>
        )
    },
}
